var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.load)?_c('div',{staticClass:"load-wrapp",attrs:{"id":"loading"}},[_c('div',{staticClass:"load-9"},[_vm._m(0),_c('p',{staticClass:"loadingText"},[_vm._v(_vm._s(_vm.$t('common.loading')))])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bubble-1"}),_c('div',{staticClass:"bubble-2"})])
}]

export { render, staticRenderFns }